import { useEffect, useState } from 'react';
import { db, collection, doc, getDocs, onSnapshot } from '../firebase';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { playSound } from '../utils/soundPlayer';

export default function useShopLogic({
  setConfirmItem,
  setConfirmQuantity,
  setDpShortage,
  setDp,
  dp,
  collectionName = 'shopItems-v2' // ✅ default to 'shopItems-v2'
}) {
  const [items, setItems] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [pseudo, setPseudo] = useState('Duelist');

  // ✅ Real-time shop items listener
  useEffect(() => {
    const shopCol = collection(db, collectionName);
    const unsubscribe = onSnapshot(shopCol, (snapshot) => {
      const itemList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setItems(itemList);
    });

    // Cleanup listener on unmount or collection change
    return () => unsubscribe();
  }, [collectionName]);

  // ✅ Real-time user DP & pseudo (still real-time for user info)
  useEffect(() => {
    const auth = getAuth();
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        const userId = user.uid;
        const userRef = doc(db, 'users', userId);
        const unsubscribeSnapshot = onSnapshot(userRef, (docSnap) => {
          if (docSnap.exists()) {
            const userData = docSnap.data();
            setDp(userData.dp || 0);
            setPseudo(userData.pseudo || 'Duelist');
          }
        });

        // ✅ Cleanup snapshot when auth changes
        return () => unsubscribeSnapshot();
      }
    });

    return () => unsubscribeAuth();
  }, [setDp]);

  const handleQuantityChange = (itemId, value) => {
    setQuantities(prev => ({
      ...prev,
      [itemId]: parseInt(value)
    }));
  };

  const handleBuyClick = (item) => {
    const quantity = quantities[item.id] || 1;
    const userId = getAuth().currentUser?.uid;

    if (!userId || !item) {
      alert('User not logged in or item invalid.');
      return;
    }

    const totalCost = item.priceDP * quantity;

    if (dp < totalCost) {
      const shortage = totalCost - dp;
      setDpShortage(shortage);
      return;
    }
    // after purchase success:
    
    setConfirmItem(item);
    setConfirmQuantity(quantity);
  };

  return {
    items,
    quantities,
    handleQuantityChange,
    handleBuyClick,
    dp,
    pseudo
  };
}
